import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Col, Label, Button, Input, InputGroup, InputGroupText, FormGroup, Row,Modal, ModalHeader, ModalBody, ModalFooter,} from "reactstrap";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import debounce from 'lodash/debounce';
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { getCrmLeadsByIdsService, getCrmDDLService, getDiscoveryCallByLeadIdService, saveOrUpdateDiscoveryCallService, getCRMLeadCommentService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import { H3, H5 } from "../../../../AbstractElements";
import TextField from "../../../common/TextField";
import Dropdown from "../../../common/DropDown";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import SelectDatePicker from "../../../common/SelectDatePicker";
import DollarInput from "../../../common/DollarInput";
import MobileField from "../../../common/MobileField";
import { generateDiscoveryCallHTML } from "./DiscoveryCallPdf";
import { getAllActiveSuburbsService } from "../../../../Services/CRMAdminServices/CRMSuburb";
import { getAllAreas } from "../../../../Services/MMPClientServices/PropertySearchService";
import React, { forwardRef, useImperativeHandle } from "react";
import { australianTax } from "../../../../Utils/Rates";


// Placeholder for a new service to update discovery call data
// import { updateDiscoveryCallService } from "../../../../Services/CRMAdminServices/DiscoveryCallService";

const initialDiscoveryData = {
    // CLIENT INFORMATION
    leadId: '',
    clientName: '',
    email: '',
    mobileNo: '',
    discoveryDate: new Date(),
    source: '',
    staff: '',
    lastSaved: '',

    // FINANCE
    budgetFrom: '',
    budgetTo: '',
    buyingFor: '',
    financePreApproved: '',
    riskAppetite: '',

    // STRATEGY FOCUS
    primaryGoal: [], // new: array for multi-select
    buyingForStrategy: '',
    strategyFocus: '', // <-- add this
    strategyType: '',  // <-- add this
    gearing: '',
    capitalGrowthExpectation: '',
    grossRentalExpectation: '',
    vacancyRateExpectation: '',

    // LOCATION
    statesPreferred: [] as string[],
    area: '',

    // PROPERTY
    propertyType: '',
    establishedOrNew: '',
    bed: 0,
    bath: 0,
    car: 0,
    minLandSize: 0,


    // COMMENTS
    comments: '',

    // CURRENT PROPERTY
    home_Zoning: '',
    home_Zoning_Name: '',
    home_Zoning_ID: '',
    Home_State: '',
    Home_Zoning: '',
    Home_Value: '',
    Home_Debt: '',
    iP1_Zoning: '',
    iP1_Zoning_Name: '',
    iP1_Zoning_ID: '',
    IP1_State: '',
    IP1_Zoning: '',
    IP1_Value: '',
    IP1_Debt: '',
    iP2_Zoning_Name: '',
    iP2_Zoning_ID: '',
    IP2_Zoning: '',
    IP2_State: '',
    IP2_Value: '',
    IP2_Debt: '',
    IP3_State: '',
    IP3_Zoning: '',
    IP3_Value: '',
    IP3_Debt: '',

    // new filds added for current property
    home_Area: '',
    home_Area_Name: '',
    home_Area_ID: '',
    Postcode: '',
    OwnerName: '',

    // OTHER ASSETS
    savingsPerMonth: '',
    cashInBank: '',
    superannuation: '',
    smsf: '',

    // CLIENT DETAILS
    employmentType: '', // new: dropdown
    taxableIncome: '', // new: numeric
    currentAge: '', // new: numeric
    familySituation: '', // new: dropdown
    kids: '', // new: dropdown
    Client1_Name: '', // new: editable
    Client2_Name: '', // new: editable
};

// Australian tax calculation (excluding Medicare).
// The brackets used to be written out here, and they went stale: this file was still using
// the 16% rate that fell to 15% on 1 July 2026, so clients were being quoted the wrong tax
// on every discovery call. They now come from the one published rates file that The Gap and
// the Platform also read - see src/Utils/Rates. Do not put a bracket back in this file.
function calculateAustralianTax(taxableIncome: number): number {
    if (taxableIncome <= 18200) return 0;
    return australianTax(taxableIncome);
}
export interface DiscoveryCallLeadRef {
  runChildFunction: () => void;
}

interface StrategyModalProps {
  open: boolean;
  toggleStrategyModal: () => void;
  leadId?: string;
}
const StrategyModal = forwardRef<DiscoveryCallLeadRef, StrategyModalProps>(({ open, toggleStrategyModal, leadId },ref) => {

    
    const { leadID } = useParams();
    const navigate = useSafeNavigate();
    const queryClient = useQueryClient();
    const [formData, setFormData] = useState<any>(initialDiscoveryData);
    const [formErrors, setFormErrors] = useState<any>({});
    const [leadDropdownData, setLeadDropdownData] = useState<any>([]);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(false);

    
    // 1. Add state for suburb lists for Home, IP1, IP2
    const [suburbLists, setSuburbLists] = useState<Record<'Home' | 'IP1' | 'IP2', { value: string; label: string; zoning?: string }[]>>({
        Home: [],
        IP1: [],
        IP2: [],
    });

 const [allComments, setAllComments] = useState<any>([]);
  const { data: leadsCommentData } = useGetRequestQuery<any>(
        ['getCRMLeadCommentService', leadID],
        () => getCRMLeadCommentService(leadID),
        { enabled: !!leadID }
    );

    useEffect(() => {
        if (leadsCommentData) {
            setAllComments(leadsCommentData?.data);
        }
    }, [leadsCommentData]);

    
 const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            setLeadDropdownData(leadsDataDDL?.data || []);
        }
    }, [leadsDataDDL]);




  const runChildFunction = () => {
    // alert("Function inside DiscoveryCallLead executed!");
    handleDownloadPdf();
    
  };
  const handleDownloadPdf = async () => {
        try {
            setIsGeneratingPdf(true);
            toast.info("Generating PDF, please wait...");

            const { page1HTML ,page2HTML} = generateDiscoveryCallHTML(formData, leadDropdownData,allComments);
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210;

            // Page 1
            const hiddenElement1 = document.createElement("div");
            hiddenElement1.style.position = "absolute";
            hiddenElement1.style.left = "-9999px";
            hiddenElement1.style.width = "800px";
            hiddenElement1.style.backgroundColor = "white";
            hiddenElement1.style.fontFamily = "Arial, sans-serif";
            hiddenElement1.innerHTML = page1HTML;
            document.body.appendChild(hiddenElement1);

            const canvas1 = await html2canvas(hiddenElement1, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                logging: false
            });
            const imgData1 = canvas1.toDataURL('image/png');
            const imgHeight1 = (canvas1.height * imgWidth) / canvas1.width;

            pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth, imgHeight1);
            document.body.removeChild(hiddenElement1);

            // Page 2
            pdf.addPage();

            const hiddenElement2 = document.createElement("div");
            hiddenElement2.style.position = "absolute";
            hiddenElement2.style.left = "-9999px";
            hiddenElement2.style.width = "800px";
            hiddenElement2.style.backgroundColor = "white";
            hiddenElement2.style.fontFamily = "Arial, sans-serif";
            hiddenElement2.innerHTML = page2HTML;
            document.body.appendChild(hiddenElement2);

            const canvas2 = await html2canvas(hiddenElement2, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                logging: false
            });
            const imgData2 = canvas2.toDataURL('image/png');
            const imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;

            pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth, imgHeight2);
            document.body.removeChild(hiddenElement2);

            // Save the PDF
            pdf.save(`Strategy-${leadID}-${formData.clientName.replace(/\s+/g, '-')}.pdf`);

            toast.success("PDF downloaded successfully!");
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error("Failed to generate PDF. Please try again.");
        } finally {
            setIsGeneratingPdf(false);
        }
    };

      // 👇 Expose the function to parent
  useImperativeHandle(ref, () => ({
    downloadPdf: handleDownloadPdf,
        runChildFunction,

  }));

//     useImperativeHandle(ref, () => ({
//     runChildFunction,
//   }));
    // Create debounced save function
    const debouncedSave = useCallback(
        debounce((data: any) => {
            setIsAutoSaving(true);
            saveDiscoveryCall(data, {
                onSuccess: () => {
                    setIsAutoSaving(false);
                    // queryClient.invalidateQueries({ queryKey: ['getDiscoveryCallByLeadId', leadID] });
                    setFormData((prev: any) => ({ ...prev, lastSaved: new Date().toLocaleString() }));
                },
                onError: (err: any) => {
                    setIsAutoSaving(false);
                    toast.error(err.message || "Failed to auto-save data.");
                },
            });
        }, 1000),
        [leadID]
    );

    // Fetch lead data to get client name etc.
    const { data: leadData } = useGetRequestQuery(
        ['getLeadByIdForDiscovery', leadID],
        () => getCrmLeadsByIdsService(leadID),
        { enabled: !!leadID }
    );

    // Fetch existing discovery call data
    const { data: discoveryCallData, isLoading: isLoadingDiscoveryData } = useGetRequestQuery(
        ['getDiscoveryCallByLeadId', leadID],
        () => getDiscoveryCallByLeadIdService(Number(leadID)),
        { enabled: !!leadID }
    );

    useEffect(() => {
        if (leadData?.data) {
            setFormData((prev: any) => ({
                ...prev,
                leadId: leadID,
                clientName: `${leadData.data.firstName} ${leadData.data.surname}`,
                email: leadData.data.email || '',
                mobileNo: leadData.data.mobileNo || leadData.data.mobile || leadData.data.phone || '',
                source: leadData.data.source,
                staff: leadData.data.staff
            }));
        }
    }, [leadData, leadID]);

    // Load existing discovery call data if available
    useEffect(() => {
        if (discoveryCallData?.data) {
            // Handle both direct data object and Rows array structure
            const existingData = discoveryCallData.data.Rows ? discoveryCallData.data.Rows[0] : discoveryCallData.data;
            console.log('existing data:-', existingData);

            if (existingData) {
                setFormData((prev: any) => ({
                    ...prev,
                    leadId: leadID,
                    clientName: existingData.clientName || existingData.ClientName || prev.clientName,
                    email: existingData.email || existingData.Email || prev.email,
                    mobileNo: existingData.mobileNo || existingData.MobileNo || existingData.mobile || existingData.Mobile || prev.mobileNo,
                    discoveryDate: existingData.discoveryDate || existingData.DiscoveryDate ? new Date(existingData.discoveryDate || existingData.DiscoveryDate) : prev.discoveryDate,
                    source: existingData.source || existingData.Source || prev.source,
                    staff: existingData.staff || existingData.Staff || prev.staff,
                    budgetFrom: existingData.budgetFrom || existingData.BudgetFrom || prev.budgetFrom,
                    budgetTo: existingData.budgetTo || existingData.BudgetTo || prev.budgetTo,
                    buyingFor: existingData.buyingFor || existingData.BuyingFor || prev.buyingFor,
                    financePreApproved: existingData.financePreApproved || existingData.FinancePreApproved || prev.financePreApproved,
                    riskAppetite: existingData.riskAppetite || existingData.RiskAppetite || prev.riskAppetite,
                    buyingForStrategy: existingData.buyingForStrategy || existingData.BuyingForStrategy || prev.buyingForStrategy,
                    strategyFocus: existingData.strategyFocus || existingData.StrategyFocus || prev.strategyFocus,
                    strategyType: existingData.strategyType || existingData.StrategyType || prev.strategyType,
                    gearing: existingData.gearing || existingData.Gearing || prev.gearing,
                    capitalGrowthExpectation: existingData.capitalGrowthExpectation || existingData.CapitalGrowthExpectation || prev.capitalGrowthExpectation,
                    grossRentalExpectation: existingData.grossRentalExpectation || existingData.GrossRentalExpectation || prev.grossRentalExpectation,
                    vacancyRateExpectation: existingData.vacancyRateExpectation || existingData.VacancyRateExpectation || prev.vacancyRateExpectation,
                    statesPreferred: (existingData.statesPreferred || existingData.StatesPreferred) ?
                        (existingData.statesPreferred || existingData.StatesPreferred).split(',').map((s: string) => s.trim()) : prev.statesPreferred,
                    area: existingData.area || existingData.Area || prev.area,
                    propertyType: existingData.propertyType || existingData.PropertyType || prev.propertyType,
                    establishedOrNew: existingData.establishedOrNew || existingData.EstablishedOrNew || prev.establishedOrNew,
                    bed: existingData.bed || existingData.Bed || prev.bed,
                    bath: existingData.bath || existingData.Bath || prev.bath,
                    car: existingData.car || existingData.Car || prev.car,
                    minLandSize: existingData.minLandSize || existingData.MinLandSize || prev.minLandSize,

                    comments: existingData.comments || existingData.Comments || prev.comments,
                    Home_State: existingData.Home_State || existingData.home_State || '',
                    Home_Zoning: existingData.Home_Zoning || existingData.home_Zoning || '',
                    Home_Value: existingData.Home_Value || existingData.home_Value || '',
                    Home_Debt: existingData.Home_Debt || existingData.home_Debt || '',
                    IP1_State: existingData.IP1_State || existingData.iP1_State || '',
                    IP1_Zoning: existingData.IP1_Zoning || existingData.iP1_Zoning || '',
                    IP1_Value: existingData.IP1_Value || existingData.iP1_Value || '',
                    IP1_Debt: existingData.IP1_Debt || existingData.iP1_Debt || '',
                    IP2_State: existingData.IP2_State || existingData.iP2_State || '',
                    IP2_Zoning: existingData.IP2_Zoning || existingData.iP2_Zoning || '',
                    IP2_Value: existingData.IP2_Value || existingData.iP2_Value || '',
                    IP2_Debt: existingData.IP2_Debt || existingData.iP2_Debt || '',
                    IP3_State: existingData.IP3_State || existingData.iP3_State || '',
                    IP3_Zoning: existingData.IP3_Zoning || existingData.iP3_Zoning || '',
                    IP3_Value: existingData.IP3_Value || existingData.iP3_Value || '',
                    IP3_Debt: existingData.IP3_Debt || existingData.iP3_Debt || '',
                    //NEW FILED ADDED FOR current property SECTION
                    Home_Area: existingData.home_Area || existingData.home_Area || '',
                    Home_Postcode: existingData.home_Postcode || existingData.home_postcode || '',
                    Home_PropertyType: existingData.home_PropertyType || existingData.Home_PropertyType || prev.home_propertyType,
                    Home_OwnerName: existingData.home_OwnerName || existingData.home_ownerName || '',

                    IP1_Area: existingData.iP1_Area || existingData.iP1_Area || '',
                    IP1_Postcode: existingData.iP1_Postcode || existingData.iP1_postcode || '',
                    IP1_PropertyType: existingData.iP1_PropertyType || existingData.IP1_PropertyType || prev.IP1_propertyType,
                    IP1_OwnerName: existingData.iP1_OwnerName || existingData.iP1_ownerName || '',
                    IP1_NetCashflow: existingData.iP1_NetCashflow || existingData.iP1_netCashflow || '',
                    IP1_GrossYield: existingData.iP1_GrossYield || existingData.iP1_grossYield || '',
                    IP1_RentWeekly: existingData.iP1_RentWeekly || existingData.iP1_rentWeekly || '',

                    IP2_Area: existingData.iP2_Area || existingData.iP2_Area || '',
                    IP2_Postcode: existingData.iP2_Postcode || existingData.iP2_postcode || '',
                    IP2_PropertyType: existingData.iP2_PropertyType || existingData.IP2_PropertyType || prev.iP2_propertyType,
                    IP2_OwnerName: existingData.iP2_OwnerName || existingData.iP2_ownerName || '',
                    IP2_NetCashflow: existingData.iP2_NetCashflow || existingData.iP2_netCashflow || '',
                    IP2_GrossYield: existingData.iP2_GrossYield || existingData.iP2_grossYield || '',
                    IP2_RentWeekly: existingData.iP2_RentWeekly || existingData.iP2_rentWeekly || '',
                    savingsPerMonth: existingData.savingsPerMonth || '',
                    cashInBank: existingData.cashInBank || '',
                    superannuation: existingData.superannuation || '',
                    smsf: existingData.smsf || '',
                    primaryGoal: existingData.primaryGoal
                        ? existingData.primaryGoal.split(',').map((s: string) => s.trim())
                        : [],
                    employmentType: existingData.employmentType || '',
                    taxableIncome: existingData.taxableIncome || prev.taxableIncome || '',
                    inflationRate: existingData.inflationRate || prev.inflationRate || '',
                    iP1: existingData.iP1 || prev.iP1 || '',//iP1 as Expected rate of return
                    currentAge: existingData.currentAge || '',
                    familySituation: existingData.familySituation || '',
                    kids: existingData.kids || '',
                    Home_Suburb: existingData.Home_Suburb || '',
                    IP1_Suburb: existingData.IP1_Suburb || '',
                    IP2_Suburb: existingData.IP2_Suburb || '',
                    // Fix for client1_name and client2_name
                    Client1_Name: existingData.client1_name || existingData.client1_Name || '',
                    Client2_Name: existingData.client2_name || existingData.client2_Name || '',
                    // Fix for client1_age and client2_age
                    Client1_Age: existingData.client1_age || existingData.client1_Age || '',
                    Client2_Age: existingData.client2_age || existingData.client2_Age || '',
                    // Fix for familySituation and kids
                    Client1_FamilySituation: existingData.client1_familysituation || existingData.client1_FamilySituation || '',
                    Client2_FamilySituation: existingData.client2_familysituation || existingData.client2_FamilySituation || '',
                    Client1_Kids: existingData.client1_kids || existingData.client1_Kids || '',
                    Client2_Kids: existingData.client2_kids || existingData.client2_Kids || '',
                    // taxableIncome section fields for Client 1 and Client 2
                    home_EmploymentType: existingData.home_EmploymentType || existingData.home_employmenttype || '',
                    home_TaxPayable: existingData.home_TaxPayable || existingData.home_taxpayable || '',
                    home_TaxableIncome: existingData.home_TaxableIncome || existingData.home_taxableincome || '',
                    home_TaxBracket: existingData.home_TaxBracket || existingData.home_taxbracket || '',
                    iP1_EmploymentType: existingData.iP1_EmploymentType || existingData.ip1_EmploymentType || existingData.ip1_employmenttype || '',
                    iP1_TaxPayable: existingData.iP1_TaxPayable || existingData.ip1_TaxPayable || existingData.ip1_taxpayable || '',
                    iP1_TaxableIncome: existingData.iP1_TaxableIncome || existingData.ip1_TaxableIncome || existingData.ip1_taxableincome || '',
                    iP1_TaxBracket: existingData.iP1_TaxBracket || existingData.ip1_TaxBracket || existingData.ip1_taxbracket || '',
                    yearsToRetire: existingData.yearsToRetire || prev.yearsToRetire || '',
                    age: existingData.age || prev.age || '',
                    // desiredincome-future filed for retirement section
                    desiredFuture: existingData.desiredFuture || prev.desiredFuture || '',
                }));
            }
        }

    }, [discoveryCallData]);

    // 3. Add effect to fetch suburbs for each property state



    useEffect(() => {
        const fetchSuburbs = async (stateKey: string, stateValue: string) => {
            if (!stateValue) {
                setSuburbLists(prev => ({ ...prev, [stateKey]: [] }));
                return;
            }
            try {
                const res = await getAllActiveSuburbsService();
                console.log("fetchsuburb:-", res);
                const sorted = (res.data || [])
                    .filter((s: any) => s.stateName === stateValue)
                    .map((s: any) => ({ value: s.suburbId, label: s.suburbName, zoning: s.suburbName, suburbId: s.suburbId, areaName: s.areaName, areaID: s.areaId, postcode: s.postcode }));


                console.log(` from useeffect suburbs for ${stateKey}:`, sorted);

                setSuburbLists(prev => {
                    const next = { ...prev, [stateKey]: sorted };
                    // Log the updated state to confirm it's applied
                    console.log(` from  fetch suburbLists.${stateKey} now is:`, next[stateKey as keyof typeof next]);
                    return next;
                });
            } catch {
                setSuburbLists(prev => ({ ...prev, [stateKey]: [] }));
            }
        };


        fetchSuburbs('Home', formData.Home_State);
        fetchSuburbs('IP1', formData.IP1_State);
        fetchSuburbs('IP2', formData.IP2_State);
    }, [formData.Home_State, formData.IP1_State, formData.IP2_State]);






    const { mutate: saveDiscoveryCall, isPending: isSaving } = useMutationRequestQuery(
        'saveOrUpdateDiscoveryCallService',
        saveOrUpdateDiscoveryCallService,
        {
            onSuccess: () => {
                toast.success("Strategy data saved successfully.");
                // queryClient.invalidateQueries({ queryKey: ['getDiscoveryCallByLeadId', leadID] });
                setFormData((prev: any) => ({ ...prev, lastSaved: new Date().toLocaleString() }));
            },
            onError: (err: any) => {
                const message =
                    err?.response?.data?.message || err?.response?.data?.error || err.message || "Failed to save data.";
                toast.error(`Error: ${message}`);
                console.error("Save Error:", err.response || err);
            },

        }
    );

    const handleValueChange = (name: string, value: any) => {
        // if (name.endsWith('_Suburb')) {
        //     const prefix = name.split('_')[0] as 'Home' | 'IP1' | 'IP2';
        //     // value is now the suburb's ID (e.g. 2)
        //     const selected = suburbLists[prefix]?.find(
        //         s => String((s as any).id) === value
        //     );
        //     const zoningId = (selected as any)?.id ?? '';


        //     console.log(`${prefix}_Suburb ID:`, value);
        //     console.log(`${prefix}_Zoning ID:`, zoningId);

        //     setFormData((prev: FormData) => ({
        //         ...prev,
        //         [name]: value,                            // Home_Suburb: 2
        //         [`${prefix}_Zoning`]: zoningId.toString() // Home_Zoning: "2"
        //     }));

        //     debouncedSave(preparePayload({
        //         ...formData,
        //         [name]: value,
        //         [`${prefix}_Zoning`]: zoningId.toString()
        //     }));
        // }


        if (name.endsWith('_Zoning')) {
            const prefix = name.split('_')[0] as 'Home' | 'IP1' | 'IP2';

            // Get the selected suburb based on suburbId (which is `value`)
            const suburbList = suburbLists[prefix] as {
                value: string;
                label: string;
                zoning?: string;
                suburbId: string;
                areaName: string;
                postcode?: string;
            }[];

            const matchedSuburb = suburbList.find(s => String(s.suburbId) === String(value));
            const postcode = matchedSuburb?.postcode || '';
            const areaName = matchedSuburb?.areaName || '';

            setFormData((prev: any) => ({
                ...prev,
                [name]: value, // Storing the suburb ID
                [`${prefix}_Postcode`]: postcode, // Updating the derived postcode field
                [`${prefix}_Area`]: areaName,
            }));

            console.log(`from handleValueChange formData: setting ${name} to`, value);
            console.log(`Auto-setting ${prefix}_Postcode to`, postcode);
            console.log(`Auto-setting ${prefix}_Area to`, areaName);

            setFormErrors((prev: any) => ({ ...prev, [name]: '' }));
            return;
        }





        // Only allow numbers for Current Age fields
        if (name.endsWith('_Age')) {
            // Remove non-numeric characters and limit to 2 digits
            const numericValue = value.replace(/[^0-9]/g, '').slice(0, 2);
            setFormData((prev: any) => {
                const newData = {
                    ...prev,
                    [name]: numericValue
                };
                debouncedSave(preparePayload(newData));
                return newData;
            });
            setFormErrors((prev: any) => ({ ...prev, [name]: '' }));
            return;
        }
        // Prevent negative values for percentage fields
        if (['capitalGrowthExpectation', 'grossRentalExpectation', 'vacancyRateExpectation'].includes(name)) {
            if (value < 0) {
                return; // Don't update if negative
            }
        }

        if (name === "inflationRate") {
            let numericValue = value.replace(/[^0-9]/g, '').slice(0, 2);
            setFormData((prev: any) => {
                const newData = {
                    ...prev,
                    [name]: numericValue
                };
                debouncedSave(preparePayload(newData));
                return newData;
            });
            setFormErrors((prev: any) => ({ ...prev, [name]: '' }));
            return;
        }
        //iP1 AS Expected Rate of Return
        if (name === "iP1") {
            let numericValue = value.replace(/[^0-9]/g, '').slice(0, 2);
            setFormData((prev: any) => {
                const newData = {
                    ...prev,
                    [name]: numericValue
                };
                debouncedSave(preparePayload(newData));
                return newData;
            });
            setFormErrors((prev: any) => ({ ...prev, [name]: '' }));
            return;
        }

        setFormData((prev: any) => {
            let updatedData = { ...prev, [name]: value };

            // Reset strategyType if strategyFocus changes
            if (name === "strategyFocus") {
                updatedData.strategyType = '';
            }

            // Auto-calculate gearing based on Value and Debt changes
            if (name.includes('_Value') || name.includes('_Debt')) {
                const propertyType = name.split('_')[0]; // Home, IP1, IP2
                const value = parseFloat(updatedData[`${propertyType}_Value`]?.replace(/[^0-9.-]/g, '') || '0');
                const debt = parseFloat(updatedData[`${propertyType}_Debt`]?.replace(/[^0-9.-]/g, '') || '0');
                const equity = value - debt;

                // Auto-set gearing based on equity
                if (value > 0) {
                    if (equity < 0) {
                        updatedData[`${propertyType}_Gearing`] = 'Negative';
                    } else {
                        updatedData[`${propertyType}_Gearing`] = 'Positive';
                    }
                }
            }

            debouncedSave(preparePayload(updatedData));
            return updatedData;
        });
        setFormErrors((prev: any) => ({ ...prev, [name]: '' }));
    };

    const handleCheckboxChange = (name: string, value: string) => {
        setFormData((prev: any) => {
            const currentValues = prev[name] as string[];
            const newData = {
                ...prev,
                [name]: currentValues.includes(value)
                    ? currentValues.filter(item => item !== value)
                    : [...currentValues, value]
            };
            debouncedSave(preparePayload(newData));
            return newData;
        });
    };

    // Helper function to prepare payload for saving
    const preparePayload = (data: any) => ({
        leadId: String(data.leadId ?? ''),
        clientName: String(data.clientName ?? ''),
        email: String(data.email ?? ''),
        mobileNo: String(data.mobileNo ?? ''),
        DiscoveryDate: data.discoveryDate,
        source: String(data.source ?? ''),
        staff: String(data.staff ?? ''),
        lastSaved: String(data.lastSaved ?? ''),
        budgetFrom: String(data.budgetFrom ?? ''),
        budgetTo: String(data.budgetTo ?? ''),
        buyingFor: String(data.buyingFor ?? ''),
        financePreApproved: String(data.financePreApproved ?? ''),
        riskAppetite: String(data.riskAppetite ?? ''),
        primaryGoal: Array.isArray(data.primaryGoal) ? data.primaryGoal.join(', ') : String(data.primaryGoal ?? ''),
        buyingForStrategy: String(data.buyingForStrategy ?? ''),
        strategyFocus: String(data.strategyFocus ?? ''),
        strategyType: String(data.strategyType ?? ''),
        gearing: String(data.gearing ?? ''),
        capitalGrowthExpectation: String(data.capitalGrowthExpectation ?? ''),
        grossRentalExpectation: String(data.grossRentalExpectation ?? ''),
        vacancyRateExpectation: String(data.vacancyRateExpectation ?? ''),
        statesPreferred: Array.isArray(data.statesPreferred) ? data.statesPreferred.join(', ') : String(data.statesPreferred ?? ''),
        area: String(data.area ?? ''),
        propertyType: String(data.propertyType ?? ''),
        establishedOrNew: String(data.establishedOrNew ?? ''),
        bed: String(data.bed ?? 0),
        bath: String(data.bath ?? 0),
        car: String(data.car ?? 0),
        lifestyleFit: Array.isArray(data.lifestyleFit) ? data.lifestyleFit.join(', ') : String(data.lifestyleFit ?? ''),
        minLandSize: String(data.minLandSize ?? 0),
        comments: String(data.comments ?? ''),
        Home_State: String(data.Home_State ?? ''),
        Home_Zoning: data.Home_Zoning ?? '',
        Home_Value: String(data.Home_Value ?? ''),
        Home_Debt: String(data.Home_Debt ?? ''),
        IP1_State: String(data.IP1_State ?? ''),
        IP1_Zoning: data.IP1_Zoning ?? '',
        IP1_Value: String(data.IP1_Value ?? ''),
        IP1_Debt: String(data.IP1_Debt ?? ''),
        IP2_State: String(data.IP2_State ?? ''),
        IP2_Zoning: data.IP2_Zoning ?? '',
        IP2_Value: String(data.IP2_Value ?? ''),
        IP2_Debt: String(data.IP2_Debt ?? ''),
        IP3_State: String(data.IP3_State ?? ''),
        IP3_Zoning: String(data.IP3_Zoning ?? ''),
        IP3_Value: String(data.IP3_Value ?? ''),
        IP3_Debt: String(data.IP3_Debt ?? ''),
        // new fields for retirement 
        Home_Area: String(data.Home_Area ?? ''),
        Home_Postcode: String(data.Home_Postcode ?? ''),
        Home_OwnerName: String(data.Home_OwnerName || data.home_ownerName || ''),
        Home_PropertyType: String(data.Home_PropertyType ?? ''),



        IP1_Area: String(data.IP1_Area ?? ''),
        IP1_Postcode: String(data.IP1_Postcode ?? ''),
        IP1_OwnerName: String(data.IP1_OwnerName || data.iP1_ownerName || ''),
        IP1_PropertyType: String(data.IP1_PropertyType ?? ''),
        IP1_NetCashflow: String(data.ip1_NetCashflow || data.IP1_NetCashflow || ''),
        IP1_GrossYield: String(data.iP1_grossYield || data.IP1_GrossYield || ''),
        IP1_RentWeekly: String(data.iP1_rentWeekly || data.IP1_RentWeekly || ''),


        IP2_Area: String(data.IP2_Area ?? ''),
        IP2_Postcode: String(data.IP2_Postcode ?? ''),
        IP2_OwnerName: String(data.IP2_OwnerName || data.iP2_ownerName || ''),
        IP2_PropertyType: String(data.IP2_PropertyType ?? ''),
        IP2_NetCashflow: String(data.ip2_netCashflow || data.IP2_NetCashflow || ''),
        IP2_GrossYield: String(data.iP2_grossYield || data.IP2_GrossYield || ''),
        IP2_RentWeekly: String(data.iP2_rentWeekly || data.IP2_RentWeekly || ''),


        savingsPerMonth: String(data.savingsPerMonth ?? ''),
        cashInBank: String(data.cashInBank ?? ''),
        superannuation: String(data.superannuation ?? ''),
        smsf: String(data.smsf ?? ''),
        employmentType: String(data.employmentType ?? ''),
        taxableIncome: String(data.taxableIncome ?? ''),
        inflationRate: String(data.inflationRate ?? ''),
        iP1: String(data.iP1 ?? ''),//iP1 as Expected Rate of Return
        currentAge: String(data.currentAge ?? ''),
        familySituation: String(data.familySituation ?? ''),
        kids: String(data.kids ?? ''),
        Home_Suburb: String(data.Home_Suburb ?? ''),
        IP1_Suburb: String(data.IP1_Suburb ?? ''),
        IP2_Suburb: String(data.IP2_Suburb ?? ''),
        client1_name: String(data.Client1_Name || data.clientName || ''),
        client2_name: String(data.Client2_Name ?? ''),
        Client1_Name: String(data.Client1_Name ?? ''),
        Client1_Age: String(data.Client1_Age ?? ''),
        Client1_EmploymentType: String(data.Client1_EmploymentType ?? ''),
        Client1_FamilySituation: String(data.Client1_FamilySituation ?? ''),
        Client1_Kids: String(data.Client1_Kids ?? ''),
        Client2_Name: String(data.Client2_Name ?? ''),
        Client2_Age: String(data.Client2_Age ?? ''),
        Home_EmploymentType: String(data.Home_EmploymentType ?? ''),
        Home_TaxPayable: String(data.Home_TaxPayable ?? ''),
        Home_TaxableIncome: String(data.Home_TaxableIncome ?? ''),
        IP1_EmploymentType: String(data.IP1_EmploymentType ?? ''),
        IP1_TaxPayable: String(data.IP1_TaxPayable ?? ''),
        IP1_TaxableIncome: String(data.IP1_TaxableIncome ?? ''),
        home_TaxPayable: String(data.home_TaxPayable ?? ''),
        home_TaxableIncome: String(data.home_TaxableIncome ?? ''),
        iP1_TaxPayable: String(data.iP1_TaxPayable ?? ''),
        iP1_TaxableIncome: String(data.iP1_TaxableIncome ?? ''),
        home_EmploymentType: String(data.home_EmploymentType ?? ''),
        iP1_EmploymentType: String(data.iP1_EmploymentType ?? ''),
        yearsToRetire: String(data.yearsToRetire ?? ''),
        Age: String(data.Age ?? ''),
        //desiredincome-future for retirement section
        desiredFuture: String(data.desiredFuture ?? ''),
    });

    const handleSave = () => {
        // Basic validation
        // Prepare payload with all fields as strings
        const payload = {
            leadId: String(formData.leadId ?? ''),
            clientName: String(formData.clientName ?? ''),
            email: String(formData.email ?? ''),
            mobileNo: String(formData.mobileNo ?? ''),
            DiscoveryDate: formData.discoveryDate,
            source: String(formData.source ?? ''),
            staff: String(formData.staff ?? ''),
            lastSaved: String(formData.lastSaved ?? ''),
            budgetFrom: String(formData.budgetFrom ?? ''),
            budgetTo: String(formData.budgetTo ?? ''),
            buyingFor: String(formData.buyingFor ?? ''),
            financePreApproved: String(formData.financePreApproved ?? ''),
            riskAppetite: String(formData.riskAppetite ?? ''),
            primaryGoal: Array.isArray(formData.primaryGoal) ? formData.primaryGoal.join(',') : String(formData.primaryGoal ?? ''),
            buyingForStrategy: String(formData.buyingForStrategy ?? ''),
            strategyFocus: String(formData.strategyFocus ?? ''),
            strategyType: String(formData.strategyType ?? ''),
            gearing: String(formData.gearing ?? ''),
            capitalGrowthExpectation: String(formData.capitalGrowthExpectation ?? ''),
            grossRentalExpectation: String(formData.grossRentalExpectation ?? ''),
            vacancyRateExpectation: String(formData.vacancyRateExpectation ?? ''),
            statesPreferred: Array.isArray(formData.statesPreferred) ? formData.statesPreferred.join(', ') : String(formData.statesPreferred ?? ''),
            area: String(formData.area ?? ''),
            propertyType: String(formData.propertyType ?? ''),
            establishedOrNew: String(formData.establishedOrNew ?? ''),
            bed: String(formData.bed ?? 0),
            bath: String(formData.bath ?? 0),
            car: String(formData.car ?? 0),
            lifestyleFit: Array.isArray(formData.lifestyleFit) ? formData.lifestyleFit.join(', ') : String(formData.lifestyleFit ?? ''),
            minLandSize: String(formData.minLandSize ?? 0),
            comments: String(formData.comments ?? ''),
            Home_State: String(formData.Home_State ?? ''),
            Home_Zoning: String(formData.Home_Zoning ?? ''),
            Home_Value: String(formData.Home_Value ?? ''),
            Home_Debt: String(formData.Home_Debt ?? ''),
            IP1_State: String(formData.IP1_State ?? ''),
            IP1_Zoning: String(formData.IP1_Zoning ?? ''),
            IP1_Value: String(formData.IP1_Value ?? ''),
            IP1_Debt: String(formData.IP1_Debt ?? ''),
            IP2_State: String(formData.IP2_State ?? ''),
            IP2_Zoning: String(formData.IP2_Zoning ?? ''),
            IP2_Value: String(formData.IP2_Value ?? ''),
            IP2_Debt: String(formData.IP2_Debt ?? ''),
            IP3_State: String(formData.IP3_State ?? ''),
            IP3_Zoning: String(formData.IP3_Zoning ?? ''),
            IP3_Value: String(formData.IP3_Value ?? ''),
            IP3_Debt: String(formData.IP3_Debt ?? ''),
            //new filed added for current property section
            Home_Area: String(formData.Home_Area ?? ''),
            Home_Postcode: String(formData.Home_Postcode ?? ''),
            Home_PropertyType: String(formData.Home_PropertyType || formData.home_propertyType || ''),
            Home_OwnerType: String(formData.Home_OwnerType ?? ''),
            Home_owner_type: String(formData.Home_OwnerType || formData.home_ownerType || ''),
            Home_OwnerName: String(formData.Home_OwnerName ?? ''),
            Home_owner_name: String(formData.Home_Owner_Name || formData.home_ownerName || ''),

            IP1_Area: String(formData.IP1_Area ?? ''),
            IP1_Postcode: String(formData.IP1_Postcode ?? ''),
            IP1_PropertyType: String(formData.IP1_PropertyType || formData.iP1_propertyType || ''),
            IP1_OwnerType: String(formData.IP1_OwnerType ?? ''),
            IP1_owner_type: String(formData.IP1_Owner_Type || formData.iP1_ownerType || ''),
            IP1_OwnerName: String(formData.IP1_OwnerName ?? ''),
            IP1_owner_name: String(formData.IP1_Owner_Name || formData.iP1_ownerName || ''),
            IP1_NetCashflow: String(formData.IP1_NetCashflow || formData.iP1_netCashflow || ''),
            IP1_GrossYield: String(formData.IP1_GrossYield || formData.iP1_grossYield || ''),
            IP1_RentWeekly: String(formData.IP1_RentWeekly || formData.iP1_rentweekly || ''),

            IP2_Area: String(formData.IP2_Area ?? ''),
            IP2_Postcode: String(formData.IP2_Postcode ?? ''),
            IP2_PropertyType: String(formData.IP2_PropertyType || formData.iP2_propertyType || ''),
            IP2_OwnerType: String(formData.IP2_OwnerType ?? ''),
            IP2_owner_type: String(formData.IP2_Owner_Type || formData.iP2_ownerType || ''),
            IP2_OwnerName: String(formData.IP2_OwnerName ?? ''),
            IP2_owner_name: String(formData.IP2_Owner_Name || formData.iP2_ownerName || ''),
            IP2_NetCashflow: String(formData.IP2_NetCashflow || formData.iP2_netCashflow || ''),
            IP2_GrossYield: String(formData.IP2_GrossYield || formData.iP2_grossYield || ''),
            IP2_RentWeekly: String(formData.IP2_RentWeekly || formData.iP2_rentweekly || ''),

            savingsPerMonth: String(formData.savingsPerMonth ?? ''),
            cashInBank: String(formData.cashInBank ?? ''),
            superannuation: String(formData.superannuation ?? ''),
            smsf: String(formData.smsf ?? ''),
            employmentType: String(formData.employmentType ?? ''),
            taxableIncome: String(formData.taxableIncome ?? ''),
            inflationRate: String(formData.inflationRate ?? ''),
            iP1: String(formData.iP1 ?? ''),//iP1 as Expected Rate of Return
            currentAge: String(formData.currentAge ?? ''),
            familySituation: String(formData.familySituation ?? ''),
            kids: String(formData.kids ?? ''),
            Home_Suburb: String(formData.Home_Suburb ?? ''),
            IP1_Suburb: String(formData.IP1_Suburb ?? ''),
            IP2_Suburb: String(formData.IP2_Suburb ?? ''),
            // Retirement section
            // taxableIncome: String(formData.taxableIncome ?? ''),
            //desiredincome-future for retirement section
            desiredFuture: String(formData.desiredFuture ?? ''),
            assets: String(formData.assets ?? ''),
            assetsNet: String(formData.assetsNet ?? ''),
            Asset: String(formData.Asset ?? ''),
            yearsToRetire: String(formData.yearsToRetire ?? ''),
            Age: String(formData.Age ?? ''),
            // taxableIncome property section
            client1_name: String(formData.Client1_Name || formData.clientName || ''),
            client2_name: String(formData.Client2_Name ?? ''),
            Client1_Name: String(formData.Client1_Name ?? ''),
            Client1_Age: String(formData.Client1_Age ?? ''),
            Client1_EmploymentType: String(formData.Client1_EmploymentType ?? ''),
            Client1_FamilySituation: String(formData.Client1_FamilySituation ?? ''),
            Client1_Kids: String(formData.Client1_Kids ?? ''),
            Client2_Name: String(formData.Client2_Name ?? ''),
            Client2_Age: String(formData.Client2_Age ?? ''),
            Home_EmploymentType: String(formData.Home_EmploymentType ?? ''),
            Home_TaxPayable: String(formData.Home_TaxPayable ?? ''),
            Home_TaxableIncome: String(formData.Home_TaxableIncome ?? ''),
            Home_TaxBracket: String(formData.Home_TaxBracket ?? ''),
            IP1_EmploymentType: String(formData.IP1_EmploymentType ?? ''),
            IP1_TaxPayable: String(formData.IP1_TaxPayable ?? ''),
            IP1_TaxableIncome: String(formData.IP1_TaxableIncome ?? ''),
            IP1_TaxBracket: String(formData.IP1_TaxBracket ?? ''),
            home_TaxPayable: String(formData.home_TaxPayable ?? ''),
            home_TaxableIncome: String(formData.home_TaxableIncome ?? ''),
            iP1_TaxPayable: String(formData.iP1_TaxPayable ?? ''),
            iP1_TaxableIncome: String(formData.iP1_TaxableIncome ?? ''),
            ip1_TaxBracket: String(formData.ip1_TaxBracket ?? ''),
            home_EmploymentType: String(formData.home_EmploymentType ?? ''),
            iP1_EmploymentType: String(formData.iP1_EmploymentType ?? ''),
        };

        saveDiscoveryCall(payload);
        console.log("payload data:-", payload);
    };

  
    const buyingForOptions = ["Living in", "Investment"];
    const financePreApprovedOptions = ["Yes I have approval", "No I will get approval", "Please help"];
    const riskAppetiteOptions = ["Low", "Medium", "High"];
    const strategyFocusOptions = [
        "Growth",
        "Cashflow",
        "Both"
    ];
    const strategyTypeOptionsMap: Record<string, string[]> = {
        "Growth - Organic": ["Buy & Hold"],
        "Growth - Manufactured": ["Any", "Knockdown & Build", "Renovation", "Subdivision"],
        "Cashflow - Yield": ["Any", "Co-living", "Dual Income", "Regional Property", "NDIS", "Rooming House"]
    };
    const gearingOptions = ["Negative", "Positive"];
    const statesOptions = ["ACT", "NT", "NSW", "QLDN", "QLDS", "SA", "TAS", "VIC", "WA"];
    const areaOptions = ["Metro", "Regional", "Coastal", "Don't Care"];
    const propertyTypeOptions = ["Renting", "Any", "Apartment", "Co Living", "Development", "Duplex / Dual Income", "House & Land", "Land", "NDIS", "Townhouse"];
    const establishedOrNewOptions = ["Any", "Brand New", "Established"];
    const bedBathCarOptions = ["1", "2", "3", "4", "5"];
    const minLandSizeOptions = [

        { value: "300", label: "300 SQM" },
        { value: "400", label: "400 SQM" },
        { value: "500", label: "500 SQM" },
        { value: "600", label: "600 SQM" },
        { value: "700", label: ">600 SQM" }

    ];
    const ownerTypeOptions = ["Owner Ocuupied", "Investor", "SMSF"];


    // Employment type options as per screenshot
    const employmentTypeOptions = [
        "PAYG",
        "Contractor",
        "Home Duties",
        "Self Employed",
        "Retired"
    ];

    // Auto-calculate Tax Payable for Home and IP1 (Client 1 and Client 2)
    useEffect(() => {
        // Helper to robustly parse numbers from form fields (removes commas and all non-numeric except . and -)
        const parseIncome = (val: any, label?: string) => {
            if (!val) return 0;
            if (typeof val === 'number') return val;
            // Remove commas and all non-numeric except . and -
            const cleaned = val.toString().replace(/,/g, '').replace(/[^0-9.-]/g, '');
            if (label) {
                console.log(`[Tax Debug] ${label} - Raw:`, val, '| Cleaned:', cleaned, '| Parsed:', parseFloat(cleaned));
            }
            return parseFloat(cleaned) || 0;
        };
        // For Home (Client 1)
        const homeIncome = parseIncome(formData.home_TaxableIncome, 'home_TaxableIncome');
        const homeTax = homeIncome ? calculateAustralianTax(homeIncome) : 0;
        // For IP1 (Client 2)
        const ip1Income = parseIncome(formData.iP1_TaxableIncome, 'iP1_TaxableIncome');
        const ip1Tax = ip1Income ? calculateAustralianTax(ip1Income) : 0;
        // Only update if changed (avoid infinite loop)
        setFormData((prev: any) => {
            let changed = false;
            const next: any = { ...prev };
            if (prev.home_TaxPayable !== (homeTax ? Math.round(homeTax).toString() : "")) {
                next.home_TaxPayable = homeTax ? Math.round(homeTax).toString() : "";
                changed = true;
            }
            if (prev.iP1_TaxPayable !== (ip1Tax ? Math.round(ip1Tax).toString() : "")) {
                next.iP1_TaxPayable = ip1Tax ? Math.round(ip1Tax).toString() : "";
                changed = true;
            }
            return changed ? next : prev;
        });
    }, [formData.home_TaxableIncome, formData.iP1_TaxableIncome]);

    // --- Retirement Calculations ---
    // Helper to robustly parse numbers from form fields (removes commas and all non-numeric except . and -)
    const parseNum = (val: any) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        // Remove commas and all non-numeric except . and -
        return parseFloat(val.toString().replace(/,/g, '').replace(/[^0-9.-]/g, '')) || 0;
    };
    // A: Desired taxableIncome
    const A = parseNum(formData.taxableIncome);
    // B: Inflation Rate (as percent)
    const B = parseNum(formData.inflationRate);


    // F: Retire in how many years?
    const F = parseNum(formData.yearsToRetire);


    const rateOfreturn = parseNum(formData.iP1)  //Expected rate of return
    // Desired Future Income 
    const desiredFuture = A * Math.pow(1 + rateOfreturn / 100, F);


    // C: Assets Required (A / (B/100)), avoid div by zero
    const raw = rateOfreturn !== 0 ? (desiredFuture / (rateOfreturn / 100)) : 0;
    const C = Math.round(raw / 100) * 100;


    // 1: Home Equity
    const eq1 = parseNum(formData.Home_Value) - parseNum(formData.Home_Debt);
    // 2: IP1 Equity
    const eq2 = parseNum(formData.IP1_Value) - parseNum(formData.IP1_Debt);
    // 3: IP2 Equity
    const eq3 = parseNum(formData.IP2_Value) - parseNum(formData.IP2_Debt);
    // 4: Cash in Bank
    const eq4 = parseNum(formData.cashInBank);
    // D: Assets Net after Debt
    const D = eq1 + eq2 + eq3 + eq4;
    // E: Asset (Shortfall/Surplus)
    const E = C - D;

    // H: Current Age (Client 1)
    const H = parseNum(formData.Client1_Age);
    // G: Age when retired (Client 1 only)
    const G = F + H;

    // Format numbers with commas and 2 decimals
    // Format numbers with commas and NO decimals
    const fmt = (num: number) => isNaN(num) ? '' : Math.round(num).toLocaleString('en-AU', { maximumFractionDigits: 0 });
    const formattedDesiredFuture = fmt(desiredFuture);





    // --- TabIndex Counter ---
    let tabIndexCounter = 20;
    // Helper to get next tabIndex
    const getTabIndex = () => tabIndexCounter++;
    // Helper to reset tabIndexCounter
    const setTabIndex = (val: number) => { tabIndexCounter = val; };
    const handleFieldBlur = () => {
        debouncedSave(preparePayload(formData));
    };

    const getVerticalTabIndex = (base: number, rowIdx: number, colIdx: number, rowCount: number) => {
        const index = base + rowIdx + (colIdx * rowCount);
        // Keep tabIndexCounter in sync for the next fields
        if (tabIndexCounter <= index) tabIndexCounter = index + 1;
        return index;
    };
    return (

<Modal isOpen={open} toggle={toggleStrategyModal} size="xl">
    <ModalHeader toggle={toggleStrategyModal} style={{color:'blue',fontWeight:'bold'}}>Strategy Details</ModalHeader>
    <ModalBody>
                 <section >
                    {/* {isLoadingDiscoveryData && (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading discovery call data...</p>
                        </div>
                    )} */}

                    <div className="d-flex ">
                        {/* <H3 className="heading-color f-w-900 my-2">Fintrack Discovery Call</H3>
                          <div className="d-flex align-items-center gap-2" style={{ marginLeft: '5px' }}>
                              <Button color="primary" className="me-2" onClick={handleSave} disabled={isSaving || isAutoSaving} tabIndex={getTabIndex()}>
                                  {isSaving ? 'Saving...' : 'Update Discovery Data'}
                              </Button>
                              {isAutoSaving && (
                                  <span className="text-muted me-2" style={{ fontSize: '0.9em' }}>
                                      Auto-saving...
                                  </span>
                              )}
                            //   <Button color="success" className="me-2" onClick={handleDownloadPdf} disabled={isGeneratingPdf} tabIndex={getTabIndex()}>
                            //       {isGeneratingPdf ? 'Generating...' : 'Discovery PDF'}
                            //   </Button>
                          </div> */}
                        <div className="d-flex align-items-center gap-2">
                             {/* <div className="d-flex align-items-center mb-1">
                                <Button color="primary" className="me-2" onClick={handleSave} disabled={isSaving || isAutoSaving} tabIndex={getTabIndex()}>
                                    {isSaving ? 'Saving...' : 'Save'}
                                </Button>
                                {isAutoSaving && (
                                    <span className="text-muted me-2" style={{ fontSize: '0.9em' }}>
                                        Auto-saving...
                                    </span>
                                )}
                                <Button color="success" className="me-2" onClick={handleDownloadPdf} disabled={isGeneratingPdf} tabIndex={getTabIndex()}>
                                    {isGeneratingPdf ? 'Generating...' : 'PDF'}
                                </Button>
                                <Button color="secondary" onClick={() => window.history.back()} tabIndex={getTabIndex()}>Back</Button>
                            </div> */}
                         </div>
                    </div>

                

                    {/* Top Section */}
                    {/* <Row className="mb-4">
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Date:</Label>
                                <div style={{ flex: 1 }}>
                                    <SelectDatePicker name="discoveryDate" value={formData.discoveryDate} setValue={handleValueChange} tabIndex={getTabIndex()} />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Lead:</Label>
                                <div style={{ flex: 1 }}>
                                    <TextField
                                        label=""
                                        type="text"
                                        name="leadID"
                                        value={formData.leadID || leadID || ''}
                                        setValue={handleValueChange}
                                        // placeholder=""
                                        design="flex"
                                        passCol="col-11"
                                        maxChars={6}
                                        tabIndex={getTabIndex()}
                                        // showClearIcon={true}
                                        autoComplete="off"
                                        disabled
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Email:</Label>
                                <div style={{ flex: 1 }}>
                                    <TextField
                                        label=""
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        setValue={handleValueChange}
                                        // placeholder="Email"
                                        design="flex"
                                        passCol="col-11"
                                        maxChars={40}
                                        showClearIcon={true}
                                        autoComplete="off"
                                        tabIndex={getTabIndex()}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="d-flex align-items-center mb-1">
                                <Button color="primary" className="me-2" onClick={handleSave} disabled={isSaving || isAutoSaving} tabIndex={getTabIndex()}>
                                    {isSaving ? 'Saving...' : 'Save'}
                                </Button>
                                {isAutoSaving && (
                                    <span className="text-muted me-2" style={{ fontSize: '0.9em' }}>
                                        Auto-saving...
                                    </span>
                                )}
                                <Button color="success" className="me-2" onClick={handleDownloadPdf} disabled={isGeneratingPdf} tabIndex={getTabIndex()}>
                                    {isGeneratingPdf ? 'Generating...' : 'PDF'}
                                </Button>
                                <Button color="secondary" onClick={() => window.history.back()} tabIndex={getTabIndex()}>Back</Button>
                            </div>
                        </Col>
                    </Row> */}
                    {/* <Row className="mb-4">

                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Mobile:</Label>
                                <div style={{ flex: 1 }}>
                                    <MobileField
                                        label=""
                                        mobileField="mobileNo"
                                        value={formData.mobileNo}
                                        setValue={handleValueChange}
                                        // placeholder="Mobile"
                                        design="flex"
                                        passCol="col-11"
                                        maxLength={14}
                                        showClearIcon={true}
                                        autoComplete="off"
                                        tabIndex={getTabIndex()}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>

                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Staff:</Label>
                                <div style={{ flex: 1 }}>
                                    <DropdownWithValueName label="" name="staff" value={formData.staff} setValue={handleValueChange} options={leadDropdownData?.staff || []} tabIndex={getTabIndex()} />
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Label className="mb-0 me-2" style={{ minWidth: 80 }}>Source:</Label>
                                <div style={{ flex: 1 }}>
                                    <DropdownWithValueName label="" name="source" value={formData.source} setValue={handleValueChange} options={leadDropdownData?.leadSources || []} tabIndex={getTabIndex()} />
                                </div>
                            </div>

                        </Col>

                    </Row> */}




                    {/* <hr style={{ border: '1px solid blue', marginTop: '1rem', marginBottom: '1rem' }} /> */}
                    {/* CLIENT DETAILS Section */}
                    <div className="heading-color mb-4" style={{ width: '50%', fontWeight: 'bold' }}>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ width: 200, color: 'blue' }}>
                                <H5 className="heading-color f-w-900"><b>CLIENT DETAILS</b></H5>
                            </div>
                            <div style={{ flex: 1, textAlign: 'center' }}> </div>
                            <div style={{ flex: 1, textAlign: 'center' }}> </div>
                        </div>

                        {[
                            // { label: 'Client Name', key: 'Name', type: 'text', disabled: true },
                            { label: 'Current Age', key: 'Age', type: 'textfield' },
                            { label: 'Family Situation', key: 'FamilySituation', type: 'dropdown', options: ["Divorced", "Defacto", "Married", "Single"] },
                            { label: 'Kids', key: 'Kids', type: 'textinput', maxChars: 100 },
                        ].map((field, rowIdx, arr) => {
                            // After rendering "Kids", reset tabIndexCounter for Employment Type
                            if (field.key === 'Kids') {
                                // Render the row, then reset tabIndexCounter
                                return (
                                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <div style={{ width: 200, color: 'black' }}>{field.label}:</div>
                                        {['Client1', 'Client2'].map((clientKey, colIdx) => {
                                            const name = `${clientKey}_${field.key}`;
                                            const commonStyle = { flex: 1, padding: '0 4px' };
                                            const showForClient2 = (field.key === 'Name' || field.key === 'Age');
                                            if (clientKey === 'Client1' || (clientKey === 'Client2' && showForClient2)) {
                                                return (
                                                    <div key={name} style={commonStyle}>
                                                        <TextField
                                                            name={name}
                                                            value={formData[name] || ''}
                                                            setValue={handleValueChange}
                                                            type="text"
                                                            maxChars={field.maxChars || 100}
                                                            tabIndex={getTabIndex()}
                                                            style={{ width: '100%' }}
                                                            onBlur={handleFieldBlur}
                                                        />
                                                    </div>
                                                );
                                            }
                                            return <div key={name} style={commonStyle}></div>;
                                        })}
                                    </div>
                                );
                            }
                            return (
                                <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <div style={{ width: 200, color: 'black' }}>{field.label}:</div>
                                    {['Client1'].map((clientKey, colIdx) => {
                                        const name = `${clientKey}_${field.key}`;
                                        const commonStyle = { flex: 1, padding: '0 4px' };
                                        const showForClient2 = (field.key === 'Name' || field.key === 'Age');
                                        if (clientKey === 'Client1' || (clientKey === 'Client2' && showForClient2)) {
                                            if (field.type === 'text') {
                                                return (
                                                    <div key={name} style={commonStyle}>
                                                        <Input
                                                            type="text"
                                                            value={
                                                                name === 'Client1_Name'
                                                                    ? (formData.Client1_Name || formData.clientName || '')
                                                                    : (formData[name] || '')
                                                            }
                                                            onChange={e => handleValueChange(name, e.target.value)}
                                                            tabIndex={getTabIndex()}
                                                            style={{ flex: 1 }}
                                                            disabled={name === 'Client1_Name'}
                                                        />
                                                    </div>
                                                );
                                            }
                                            if (field.type === 'textfield') {
                                                return (
                                                    <div key={name} style={commonStyle}>
                                                        <TextField
                                                            name={name}
                                                            value={formData[name] || ''}
                                                            setValue={handleValueChange}
                                                            type="text"
                                                            maxChars={2}
                                                            tabIndex={getTabIndex()}
                                                            style={{ width: '9.5ch' }}
                                                            onBlur={handleFieldBlur}
                                                        />
                                                    </div>
                                                );
                                            }
                                            if (field.type === 'dropdown') {
                                                return (
                                                    <div key={name} style={{ minWidth: 0, width: '150px' }}>
                                                        <Dropdown
                                                            label=""
                                                            name={name}
                                                            value={formData[name]}
                                                            setValue={handleValueChange}
                                                            options={field.options || []}
                                                            tabIndex={getTabIndex()}
                                                            onBlur={handleFieldBlur}
                                                        />
                                                    </div>
                                                );
                                            }
                                        }
                                        return <div key={name} style={commonStyle}></div>;
                                    })}
                                </div>
                            );
                        })}
                    </div>


                    {/* taxableIncome Section */}
                    {/* <H5 className="heading-color f-w-900 my-2">taxableIncome PROPERTY</H5> */}
                    <div className="heading-color mb-4" style={{ width: '50%', fontWeight: 'bold' }}>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ width: 100, color: 'blue' }}>
                                <H5 className="heading-color f-w-900"><b>INCOME</b></H5>
                            </div>
                            <div style={{ flex: 1, textAlign: 'center' }}>Client 1</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>Client 2</div>
                        </div>

                        {[
                            { label: 'Employment Type', key: 'EmploymentType', isDropdown: true, optionsKey: 'employmentTypeOptions' },
                            { label: 'Taxable Income', key: 'TaxableIncome', isDollar: true },
                            { label: 'Tax Payable', key: 'TaxPayable', isDollar: true },
                            { label: 'Tax Bracket', key: 'TaxBracket' },
                        ].map((field, rowIdx) => (
                            <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <div style={{ width: 200, color: 'black' }}>{field.label}:</div>
                                {['Home', 'IP1'].map((col, colIdx) => {
                                    let name = '';
                                    if (col === 'Home') {
                                        name = `home_${field.key}`;
                                    } else if (col === 'IP1') {
                                        name = `iP1_${field.key}`;
                                    }
                                    const commonStyle = { flex: 1, padding: '0 4px' };
                                    if (field.isDropdown) {
                                        return (
                                            <div key={name} style={commonStyle}>
                                                <Dropdown
                                                    label=""
                                                    name={name}
                                                    value={formData[name]}
                                                    setValue={handleValueChange}
                                                    options={employmentTypeOptions}
                                                    tabIndex={getVerticalTabIndex(30, rowIdx, colIdx, 4)}
                                                />
                                            </div>

                                        );
                                    }
                                    // Taxable taxableIncome: editable, appears above Tax Payable
                                    if (field.key === 'TaxableIncome') {
                                        return (
                                            <div key={name} style={commonStyle}>
                                                <DollarInput
                                                    name={name}
                                                    value={formData[name]}
                                                    setValue={handleValueChange}
                                                    // placeholder="99,999,999"
                                                    limit={8}
                                                    tabIndex={getVerticalTabIndex(30, rowIdx, colIdx, 4)}
                                                />
                                            </div>
                                        );
                                    }
                                    // Tax Payable: calculated, appears below Taxable taxableIncome
                                    if (field.key === 'TaxPayable') {
                                        // Format with commas
                                        let displayValue = formData[name];
                                        if (displayValue && !isNaN(Number(displayValue))) {
                                            const num = Number(displayValue);
                                            displayValue = Math.round(num).toLocaleString('en-AU', { maximumFractionDigits: 0 });
                                        }
                                        return (
                                            <div key={name} style={commonStyle}>
                                                <DollarInput
                                                    name={name}
                                                    value={displayValue}
                                                    setValue={() => { }}
                                                    // placeholder="99,999,999"
                                                    limit={8}
                                                    tabIndex={getVerticalTabIndex(30, rowIdx, colIdx, 4)}
                                                    disabled
                                                />
                                            </div>
                                        );
                                    }
                                    // Tax Bracket: calculated, appears below  taxPayable
                                    if (field.key === 'TaxBracket') {
                                        // Calculate tax bracket percentage based on taxable income
                                        let taxBracketPercentage = '';
                                        const taxableIncomeKey = name.replace('TaxBracket', 'TaxableIncome');
                                        const taxableIncome = parseFloat(formData[taxableIncomeKey]?.replace(/[^0-9.-]/g, '') || '0');

                                        // Calculate highest tax bracket percentage based on income
                                        // Using client's example: $100k -> 30%, $150k -> 37%, $198k -> 45%
                                        if (taxableIncome > 0) {
                                            if (taxableIncome < 100000) {
                                                // For incomes below $100k, use a sliding scale up to 30%
                                                const percentage = Math.min(Math.floor(taxableIncome / 5000), 30);
                                                taxBracketPercentage = `${percentage}`;
                                            } else if (taxableIncome < 150000) {
                                                // For incomes $100k-$150k, use 30-37%
                                                const percentage = Math.min(30 + Math.floor((taxableIncome - 100000) / 10000), 37);
                                                taxBracketPercentage = `${percentage}`;
                                            } else if (taxableIncome < 198000) {
                                                // For incomes $150k-$198k, use 37-45%
                                                const percentage = Math.min(37 + Math.floor((taxableIncome - 150000) / 10000), 45);
                                                taxBracketPercentage = `${percentage}`;
                                            } else {
                                                // For incomes $198k and above, cap at 45%
                                                taxBracketPercentage = '45';
                                            }

                                            // Ensure percentage is an integer and doesn't exceed 99
                                            const numericPercentage = parseInt(taxBracketPercentage);
                                            if (!isNaN(numericPercentage)) {
                                                taxBracketPercentage = `${Math.min(numericPercentage, 99)}`;
                                            }
                                        }

                                        // Update formData with calculated tax bracket (without % symbol in the data)
                                        // Remove % if it exists in the current value for comparison
                                        const currentValue = formData[name]?.replace('%', '') || '';
                                        if (currentValue !== taxBracketPercentage) {
                                            // Update the form data directly without calling handleValueChange
                                            // to avoid triggering multiple saves
                                            setFormData((prev: any) => ({
                                                ...prev,
                                                [name]: taxBracketPercentage
                                            }));
                                        }

                                        return (
                                            <div key={name} style={commonStyle}>


                                                <InputGroup style={{ width: '4rem' }}>
                                                    <Input
                                                        type="text"
                                                        name={name}
                                                        value={formData[name] ? formData[name] + '%' : ''}
                                                        // placeholder="0"
                                                        tabIndex={getTabIndex()}
                                                        disabled
                                                        style={{ width: '2rem' }}
                                                        maxLength={2}

                                                    />
                                                    {/* <InputGroupText>%</InputGroupText> */}

                                                </InputGroup>
                                            </div>
                                        );
                                    }

                                })}
                            </div>
                        ))}
                    </div>

                    {/* CURRENT PROPERTY Section */}
                    {/* <H5 className="heading-color f-w-900 my-2">CURRENT PROPERTY</H5> */}
                    <div className=" heading-color mb-4" style={{ width: '90%', fontWeight: 'bold' }}>
                        <div style={{ display: 'flex', marginBottom: 8 }}>
                            <div style={{ width: 200, color: 'blue' }}>   <H5 className="heading-color f-w-900"> <b>CURRENT PROPERTY</b></H5></div>
                            <div style={{ flex: 1, textAlign: 'center' }}>HOME</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>IP1</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>IP2</div>
                            {/* Remove IP3 */}
                        </div>
                        {[{ label: 'State', key: 'State' }, { label: 'Suburb', key: 'Zoning' }, { label: 'Area', key: 'Area' }, { label: 'Postcode', key: 'Postcode' }, { label: 'Property Type', key: 'PropertyType' }, { label: 'Value', key: 'Value' }, { label: 'Debt', key: 'Debt' }, { label: 'Equity', key: 'Equity' }, { label: 'Rent Weekly', key: 'RentWeekly' }, { label: 'Net Cashflow', key: 'NetCashflow' }, { label: 'Gross Yield', key: 'GrossYield' }]
                            .map((field, rowIdx) => (
                                <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <div style={{ width: 200, color: 'black' }}>{field.label}:</div>
                                    {['Home', 'IP1', 'IP2'].map((col, colIdx) => {
                                        const name = `${col}_${field.key}`;
                                        let options: any = [];
                                        if (field.key === 'State') options = statesOptions;
                                        if (field.key === 'Zoning') options = suburbLists[col as 'Home' | 'IP1' | 'IP2'] || [];
                                        // Calculate Equity
                                        if (field.key === 'Equity') {
                                            const value = parseFloat(formData[`${col}_Value`]?.replace(/[^0-9.-]/g, '') || '0');
                                            const debt = parseFloat(formData[`${col}_Debt`]?.replace(/[^0-9.-]/g, '') || '0');
                                            const equity = value - debt;
                                            const formattedEquity = !isNaN(equity) ?
                                                (equity < 0 ? `-$ ${Math.abs(Math.round(equity)).toLocaleString('en-AU', { maximumFractionDigits: 0 })}` : `$ ${Math.round(equity).toLocaleString('en-AU', { maximumFractionDigits: 0 })}`) : '';
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <Input
                                                        type="text"
                                                        value={formattedEquity}
                                                        disabled
                                                        style={{
                                                            backgroundColor: '#f8f9fa',
                                                            border: '1px solid #ced4da',
                                                            color: equity < 0 ? '#dc3545' : '#28a745'
                                                        }}
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (field.key === 'State') {
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <Dropdown
                                                        label=""
                                                        name={name}
                                                        value={formData[name]}
                                                        setValue={handleValueChange}
                                                        options={statesOptions}
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}
                                                    />
                                                </div>
                                            );
                                        }
                                        // if (field.key === 'Suburb') {
                                        //     const sorted = (suburbLists[col as 'Home' | 'IP1' | 'IP2'] || [])
                                        //         .sort((a, b) => String(a.id).localeCompare(String(b.id)));

                                        //     return (
                                        //         <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                        //             <DropdownwithValueName
                                        //                 label=""
                                        //                 name={name}
                                        //                 value={formData[name]}
                                        //                 setValue={handleValueChange}
                                        //                 options={sorted as { id: number; label: string; value: string; zoning?: string }[]}
                                        //                 optionLabel="label"
                                        //                 optionValue="id"
                                        //                 tabIndex={getTabIndex()}
                                        //             />
                                        //         </div>
                                        //     );
                                        // }

                                        if (field.key === 'Zoning') {
                                            const sortedSuburbs = [...(suburbLists[col as 'Home' | 'IP1' | 'IP2'] || [])]
                                                .map(s => ({ value: String(s.value), label: s.label }))
                                                .sort((a, b) => a.label.localeCompare(b.label));

                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <DropdownWithValueName
                                                        label=""
                                                        name={name}
                                                        value={String(formData[name] || '')}
                                                        setValue={handleValueChange}
                                                        options={sortedSuburbs}
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }

                                        {/*if (field.key === 'Area') {
                                            type SuburbKey = "Home" | "IP1" | "IP2";
                                            const key = col as SuburbKey;

                                            const suburbId = formData[`${key}_Zoning`];

                                            const matchedAreas = ((suburbLists[col as keyof typeof suburbLists] || []) as {
                                                value: string;
                                                label: string;
                                                zoning?: string;
                                                suburbId: string;
                                                areaName?: string;
                                                areaId?: string;
                                            }[]).filter(s => String(s.suburbId) === String(suburbId));


                                            const areaOptions = matchedAreas
                                                .filter(a => a.areaName)
                                                .map(a => ({
                                                    label: a.areaName!,
                                                    value: a.areaName!
                                                }));



                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <DropdownWithValueName
                                                        label=""
                                                        name={name}
                                                        value={String(formData[name] || '')}
                                                        setValue={handleValueChange}
                                                        options={areaOptions}
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }*/ }

                                        if (field.key === 'Area') {

                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <Input
                                                        type="text"
                                                        name={name}
                                                        value={formData[name] || ''}
                                                        setValue={handleValueChange}
                                                        disabled
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }

                                        if (field.key === 'Postcode') {
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 2px' }}>
                                                    <Input
                                                        type="number"
                                                        name={name}
                                                        value={formData[name] || ''}
                                                        setValue={handleValueChange}
                                                        // placeholder="9999"
                                                        maxLength={4}
                                                        style={{ width: '9.5ch' }}
                                                        disabled
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (field.key === 'PropertyType') {
                                            const PropertyType = propertyTypeOptions.map(s => ({
                                                value: s,
                                                label: s,
                                            })).sort((a, b) => a.label.localeCompare(b.label));

                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <DropdownWithValueName
                                                        label=""
                                                        name={name}
                                                        value={String(formData[name] || '')}
                                                        setValue={handleValueChange}
                                                        // options={PropertyType}
                                                        options={PropertyType}
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }
                                        if (field.key === 'OwnerName') {
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <Input
                                                        type="text"
                                                        name={name}
                                                        value={formData[name] || ''}
                                                        onChange={e => handleValueChange(name, e.target.value)}
                                                        // placeholder="Enter Owner Name"
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }

                                        if ((col === 'IP1' || col === 'IP2') && field.key === 'RentWeekly') {
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <DollarInput name={name} value={formData[name]} setValue={handleValueChange}limit={8} tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}

                                                    />
                                                </div>
                                            );
                                        }
                                        //netcashflow 
                                        if ((col === 'IP1' || col === 'IP2') && field.key === 'NetCashflow') {
                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <InputGroup>
                                                        <InputGroupText>$</InputGroupText>
                                                        <Input
                                                            name={name}
                                                            value={formData[name] || ''}
                                                            onChange={e => {
                                                                let raw = e.target.value;

                                                                // Remove commas for raw number processing
                                                                raw = raw.replace(/,/g, '');

                                                                // Allow only optional "-" and digits
                                                                if (/^-?\d*$/.test(raw)) {
                                                                    const isNegative = raw.startsWith('-');
                                                                    const absValue = isNegative ? raw.slice(1) : raw;

                                                                    // Limit to 8 digits max
                                                                    const limited = absValue.slice(0, 8);

                                                                    // Format with commas inline
                                                                    const withCommas = limited.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                                                                    const final = isNegative ? '-' + withCommas : withCommas;

                                                                    handleValueChange(name, final);
                                                                }
                                                            }}
                                                            // placeholder="$100"
                                                            style={{
                                                                color: parseNum(formData[name]) < 0 ? 'red' : 'black',
                                                            }}
                                                            tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}
                                                        />
                                                    </InputGroup>

                                                </div>
                                            );
                                        }


                                        if ((col === 'IP1' || col === 'IP2') && field.key === 'GrossYield') {
                                            const rent = parseFloat(formData[`${col}_RentWeekly`]?.replace(/[^0-9.-]/g, '') || '0');
                                            const value = parseFloat(formData[`${col}_Value`]?.replace(/[^0-9.-]/g, '') || '0');


                                            const grossYield = value !== 0 ? ((rent * 52) / value * 100).toFixed(2) : '0.00';

                                            // const grossYield = value !== 0 ? Math.floor((rent * 52) / value) : 0; // multiply by 100 to get percentage
                                            const formattedYield = !isNaN(Number(grossYield))
                                                ? `${grossYield}%`
                                                : '';




                                            return (
                                                <div key={name} style={{ flex: 1, padding: '0 4px' }}>
                                                    <Input
                                                        type="text"
                                                        name={name}
                                                        value={formattedYield}
                                                        onChange={e => handleValueChange(name, e.target.value)}
                                                        style={{ width: '9.5ch' }}
                                                        disabled
                                                        tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)}
                                                    />
                                                </div>
                                            );
                                        } if (
                                            field.key === 'RentWeekly' ||
                                            field.key === 'NetCashflow' ||
                                            field.key === 'GrossYield'
                                        ) {
                                            return <div key={name} style={{ flex: 1, padding: '0 4px' }} />;
                                        }


                                        // Value and Debt: not bold
                                        return <div key={name} style={{ flex: 1, padding: '0 4px' }}><DollarInput name={name} value={formData[name]} setValue={handleValueChange}  limit={8} tabIndex={getVerticalTabIndex(23, rowIdx, colIdx, 12)} /></div>;
                                    })}
                                </div>
                            ))}
                    </div>
                    {/* OTHER ASSETS Section */}
                    <H5 className="heading-color f-w-900 my-2">OTHER ASSETS</H5>
                    <Row className="align-items-center mb-1">
                        <Col md={3}><Label style={{ color: 'black' }}>Savings per month:</Label></Col>
                        <Col md={2}>
                            <DollarInput name="savingsPerMonth" value={formData.savingsPerMonth} setValue={handleValueChange} limit={8} tabIndex={getTabIndex()} />
                        </Col>
                        <Col md={3}><Label style={{ color: 'black' }}>Cash in Bank:</Label></Col>
                        <Col md={2}>
                            <DollarInput name="cashInBank" value={formData.cashInBank} setValue={handleValueChange}  limit={8} tabIndex={getTabIndex()} />
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-1">
                        <Col md={3}><Label style={{ color: 'black' }}>Superannuation:</Label></Col>
                        <Col md={2}>
                            <DollarInput name="superannuation" value={formData.superannuation} setValue={handleValueChange}  limit={8} tabIndex={getTabIndex()} />
                        </Col>
                        <Col md={3}><Label style={{ color: 'black' }}>SMSF:</Label></Col>
                        <Col md={2}>
                            <DollarInput name="smsf" value={formData.smsf} setValue={handleValueChange}  limit={8} tabIndex={getTabIndex()} />
                        </Col>
                    </Row>

                    <h5 className="heading-color f-w-900 my-2">
                        RETIREMENT
                    </h5>
                    {/* RETIREMENT Section */}
               <div className="g-3">
    {/* Row 1 */}
    <Row className="align-items-center mb-1">
        <Col md={3}>
            <Label style={{ color: 'black' }}>Desired Income Today's Value</Label>
        </Col>
        <Col md={2}>
            <DollarInput name="taxableIncome" value={formData.taxableIncome} setValue={handleValueChange} limit={8} tabIndex={getTabIndex()} />
        </Col>
        <Col md={3}>
            <Label style={{ color: 'black' }}>Desired Income - Future Value</Label>
        </Col>
        <Col md={2}>
            <DollarInput name="desiredFuture" value={formattedDesiredFuture} setValue={handleValueChange} limit={8} disabled tabIndex={getTabIndex()} />
        </Col>
    </Row>

    {/* Row 2 */}
    <Row className="align-items-center mb-1">
        <Col md={3}>
            <Label style={{ color: 'black' }}>Inflation Rate</Label>
        </Col>
        <Col md={2}>
            <InputGroup className="mb-3" style={{width:'10.5ch'}}>
                <Input
                    name="inflationRate"
                    value={formData.inflationRate}
                    onChange={e => handleValueChange("inflationRate", e.target.value)}
                    type="text"
                    style={{ width: '1rem' }}
                    maxLength={2}
                    tabIndex={getTabIndex()}
                />
                <InputGroupText>%</InputGroupText>
            </InputGroup>
        </Col>
        <Col md={3}>
            <Label style={{ color: 'black' }}>Required Net Assets</Label>
        </Col>
        <Col md={2}>
            <DollarInput name="assets" value={fmt(C)} setValue={() => { }} limit={8} tabIndex={getTabIndex()} disabled />
        </Col>
    </Row>

    {/* Row 3 */}
    <Row className="align-items-center mb-1">
        <Col md={3}>
            <Label style={{ color: 'black' }}>Years to Retirement</Label>
        </Col>
        <Col md={2}>
            <InputGroup className="mb-3" style={{width:'16.5ch'}}>
                <Input
                    name="yearsToRetire"
                    value={formData.yearsToRetire}
                    onChange={e => handleValueChange("yearsToRetire", e.target.value)}
                    className="text-center"
                    maxLength={2}
                    tabIndex={getTabIndex()}
                />
                <InputGroupText>Years</InputGroupText>
            </InputGroup>
        </Col>
        <Col md={3}>
            <Label style={{ color: 'black' }}>Current Net Assets</Label>
        </Col>
        <Col md={2}>
            <DollarInput name="assetsNet" value={fmt(D)} setValue={() => { }} limit={8} tabIndex={getTabIndex()} disabled />
        </Col>
    </Row>

    {/* Row 4 */}
    <Row className="align-items-center mb-1">
        <Col md={3}>
            <Label style={{ color: 'black' }}>Expected Rate of Return</Label>
        </Col>
        <Col md={2}>
            <InputGroup className="mb-3" style={{width:'10.5ch'}}>
                <Input
                    name="iP1"
                    value={formData.iP1}
                    onChange={e => handleValueChange("iP1", e.target.value)}
                    type="text"
                    style={{ width: '1rem' }}
                    maxLength={2}
                    tabIndex={getTabIndex()}
                />
                <InputGroupText>%</InputGroupText>
            </InputGroup>
        </Col>
        <Col md={3}>
            <Label style={{ color: 'black' }}>Asset (Surplus / Shortfall)</Label>
        </Col>
        <Col md={2}>
            <DollarInput
                name="Asset"
                value={fmt(E)}
                setValue={() => { }}
                limit={8}
                tabIndex={getTabIndex()}
                disabled
                style={{
                    fontWeight: 'bold',
                    color: E < 0 ? '#28a745' : E > 0 ? '#dc3545' : undefined
                }}
            />
        </Col>
    </Row>
</div>



                    {/* STRATEGY FOCUS Section */}
                    <H5 className="heading-color f-w-900 my-2">STRATEGY FOCUS</H5>
                    {/* <hr/> */}
                    <div className="g-3">
                        {/* <Row className="align-items-center mb-1">
                            <Col md={4}>
                                <Label  style={{ color: 'black' }}>Are you buying to live in or investment?</Label>
                            </Col>
                            <Col md={2}>
                                <Dropdown label="" name="buyingForStrategy" value={formData.buyingForStrategy} setValue={handleValueChange} options={buyingForOptions} />
                            </Col>
                        </Row> */}
                        <Row className="align-items-center mb-1">
                            {/* <Col md={2}>
                                <Label style={{ color: 'black', minWidth: '200px' }} >Primary Goal:</Label>
                            </Col>
                            <Col md={8}>
                                <div className="d-flex flex-wrap " style={{ flex: 1 }}>
                                    <FormGroup check inline>
                                        {['POHL', 'Wealth Building', 'Tax Minimisation', 'Retirement'].map((goal, idx) => (
                                            <Label check key={goal} className="me-5">
                                                <Input type="checkbox" onChange={() => handleCheckboxChange('primaryGoal', goal)} checked={formData.primaryGoal.includes(goal)} tabIndex={getTabIndex()} />
                                                {goal}
                                            </Label>
                                        ))}
                                    </FormGroup>
                                </div>
                            </Col> */}
                        </Row>
                        <Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Strategy Focus</Label>
                            </Col>
                            <Col md={2}>
                                <Dropdown label="" name="strategyFocus" value={formData.strategyFocus} setValue={handleValueChange} options={strategyFocusOptions} tabIndex={getTabIndex()} />
                            </Col>
                        </Row>


                        {/*<Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Strategy Type</Label>
                            </Col>
                            <Col md={2}>
                                <Dropdown label="" name="strategyType" value={formData.strategyType} setValue={handleValueChange} options={strategyTypeOptionsMap[formData.strategyFocus] || []} tabIndex={getTabIndex()} />
                            </Col>
                        </Row>
                        <Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Gearing</Label>
                            </Col>
                            <Col md={2}>
                                <Dropdown label="" name="gearing" value={formData.gearing} setValue={handleValueChange} options={gearingOptions} tabIndex={getTabIndex()} />
                            </Col>
                        </Row>
                        <Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Capital Growth %</Label>
                            </Col>
                            <Col md={4}>
                                <div className="d-flex align-items-center">
                                    <TextField name="capitalGrowthExpectation" value={formData.capitalGrowthExpectation} setValue={handleValueChange} type="number" style={{ width: '4rem' }} maxChars={2} tabIndex={getTabIndex()} />
                                    <span className="ms-2 me-3 mb-1">% </span>
                                    <span>Average is between 4% and 10%</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Gross Rental %</Label>
                            </Col>
                            <Col md={4}>
                                <div className="d-flex align-items-center">
                                    <TextField name="grossRentalExpectation" value={formData.grossRentalExpectation} setValue={handleValueChange} type="number" style={{ width: '4rem' }} maxChars={2} tabIndex={getTabIndex()} />
                                    <span className="ms-2 me-3">%</span>
                                    <span>Average is between 4% and 6%</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className="align-items-center mb-1">
                            <Col md={2}>
                                <Label style={{ color: 'black' }}>Vacancy Rate %</Label>
                            </Col>
                            <Col md={4}>
                                <div className="d-flex align-items-center">
                                    <TextField name="vacancyRateExpectation" value={formData.vacancyRateExpectation} setValue={handleValueChange} type="number" style={{ width: '4rem' }} maxChars={2} tabIndex={getTabIndex()} />
                                    <span className="ms-2 me-3">%</span>
                                    <span>Average is less than 3%</span>
                                </div>
                            </Col>
                        </Row>*/}
                    </div>
                    {/* Property Section */}
                    {/* <hr/> */}
                    <div className="row g-3 mb-2">
                        <Col md={2}>
                            <Label className="me-2" style={{ color: 'black', minWidth: '200px' }} >States Preferred</Label>
                        </Col>
                        <Col md={8}>
                            <div className="d-flex flex-wrap" style={{ flex: 1 }}>
                                {statesOptions.map((state, idx) => (
                                    <FormGroup check inline key={state}>
                                        <Input type="checkbox" onChange={() => handleCheckboxChange('statesPreferred', state)} checked={formData.statesPreferred.includes(state)} tabIndex={getTabIndex()} />
                                        <Label check>{state}</Label>
                                    </FormGroup>
                                ))}
                            </div>
                        </Col>
                        {/* <Col md={12}>
                            <div className="d-flex align-items-center mb-2">
                                <Label className="me-2"  style={{ color: 'black',   minWidth: '200px'}} >States Preferred</Label>
                                <div className="d-flex flex-wrap" style={{ flex: 1 }}>
                                    {statesOptions.map(state => (
                                        <FormGroup check inline key={state}>
                                            <Input type="checkbox" onChange={() => handleCheckboxChange('statesPreferred', state)} checked={formData.statesPreferred.includes(state)} />
                                            <Label check>{state}</Label>
                                        </FormGroup>
                                    ))}
                                </div>
                            </div>
                        </Col> */}
                    </div>



                    {/* <div className="row g-3 mb-2">   <Col md={2}>
                        <Label className="me-2" style={{ color: 'black', minWidth: '250px' }}>Area</Label>
                    </Col>
                        <Col md={2}>
                            <div >
                                <Dropdown label="" name="area" value={formData.area} setValue={handleValueChange} options={areaOptions} tabIndex={getTabIndex()} />
                            </div>
                        </Col></div>



                    <div className="row g-3 mb-2">
                        <Col md={2}>
                            <Label className="me-2" style={{ color: 'black', minWidth: '200px' }}>Property Type</Label>
                        </Col>
                        <Col md={10}>
                            <div className="d-flex flex-wrap " style={{ flex: 1 }} >
                                {propertyTypeOptions.map((type, idx) => (
                                    <FormGroup check inline key={type}>
                                        <Input
                                            type="checkbox"
                                            value={type}
                                            checked={formData.propertyType.includes(type)}
                                            onChange={() => handleCheckboxChange('propertyType', type)}
                                            tabIndex={getTabIndex()}
                                        />
                                        <Label check>{type}</Label>
                                    </FormGroup>
                                ))}

                            </div>
                        </Col>

                    </div>



                    <div className="row g-3 mb-2 ">
                        <Col md={2}>
                            <Label className="me-2" style={{ color: 'black', minWidth: '200px' }}>Established OR New</Label>
                        </Col>
                        <Col md={2}>
                            <div >
                                <Dropdown label="" name="establishedOrNew" value={formData.establishedOrNew} setValue={handleValueChange} options={establishedOrNewOptions} tabIndex={getTabIndex()} />
                            </div>

                        </Col>
                    </div>
                    <div className="row g-3 mb-2">
                        <Col md={2}>
                            <Label className="me-2" style={{ color: 'black', minWidth: '200px' }}>Bed / Bath / Car</Label>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex" >
                                <Dropdown label="" name="bed" value={formData.bed} setValue={handleValueChange} options={bedBathCarOptions} tabIndex={getTabIndex()} />
                                <Dropdown label="" name="bath" value={formData.bath} setValue={handleValueChange} options={bedBathCarOptions} tabIndex={getTabIndex()} />
                                <Dropdown label="" name="car" value={formData.car} setValue={handleValueChange} options={bedBathCarOptions} tabIndex={getTabIndex()} />
                            </div>
                        </Col>
                    </div>
                    <div className="row g-3 mb-2">
                        <Col md={2}>
                            <div className="d-flex align-items-center mb-2">
                                <Label className="me-2" style={{ color: 'black', minWidth: '200px' }}>Minimum Land Size (SQM)</Label>
                            </div>
                        </Col>
                        <Col md={2}>
                            <DropdownWithValueName label="" name="minLandSize" value={formData.minLandSize} setValue={handleValueChange} options={minLandSizeOptions} tabIndex={getTabIndex()} />
                        </Col>
                    </div>
*/}
                    

                    {/* COMMENTS Section */}
                    {/* <H5 className="heading-color f-w-900 my-2">COMMENTS AND NON NEGOTIABLES</H5>
                    <div className=" mb-2">
                        <TextField name="comments" value={formData.comments} setValue={handleValueChange} type="textarea" rows={7} tabIndex={getTabIndex()} />
                    </div> */}

                </section>
                <ModalFooter>
          <Button color="danger" onClick={toggleStrategyModal}>
            Save & Close
          </Button>
        </ModalFooter>
                </ModalBody>
        </Modal>
    );
});

export default StrategyModal; 